module.exports = __webpack_public_path__ + "static/media/81.b9fc20a2.png";